import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ModoProvider } from './providers/modoContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ModoProvider>
      <App />
    </ModoProvider>
  </React.StrictMode>
);